package chand.wordvoyage.ui

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

// ── Primary: Deep Violet ──────────────────────────────────────────────────────
private val Purple80        = Color(0xFF6200EA)   // primary
private val PurpleContainer = Color(0xFFEDE7F6)   // primaryContainer
private val OnPurple        = Color(0xFFFFFFFF)   // onPrimary
private val OnPurpleContainer = Color(0xFF20004A) // onPrimaryContainer

// ── Secondary: Vivid Teal ──────────────────────────────────────────────────────
private val Teal80          = Color(0xFF00897B)   // secondary
private val TealContainer   = Color(0xFFB2DFDB)   // secondaryContainer
private val OnTeal          = Color(0xFFFFFFFF)   // onSecondary
private val OnTealContainer = Color(0xFF001F1D)   // onSecondaryContainer

// ── Tertiary: Vivid Orange ─────────────────────────────────────────────────────
private val Orange80        = Color(0xFFE65100)   // tertiary
private val OrangeContainer = Color(0xFFFFE0B2)   // tertiaryContainer
private val OnOrange        = Color(0xFFFFFFFF)   // onTertiary
private val OnOrangeContainer = Color(0xFF2E1500) // onTertiaryContainer

// ── Surface / Background ───────────────────────────────────────────────────────
private val Background      = Color(0xFFF5F0FF)   // soft lavender background
private val Surface         = Color(0xFFFFFFFF)
private val SurfaceVariant  = Color(0xFFEDE7F6)
private val OnBackground    = Color(0xFF1C1B1F)
private val OnSurface       = Color(0xFF1C1B1F)
private val OnSurfaceVariant = Color(0xFF49454F)
private val Outline         = Color(0xFF7965AF)

// ── Error ──────────────────────────────────────────────────────────────────────
private val Error           = Color(0xFFB00020)
private val ErrorContainer  = Color(0xFFFFDAD6)
private val OnError         = Color(0xFFFFFFFF)
private val OnErrorContainer = Color(0xFF410002)

val WordVoyageColorScheme = lightColorScheme(
    primary             = Purple80,
    onPrimary           = OnPurple,
    primaryContainer    = PurpleContainer,
    onPrimaryContainer  = OnPurpleContainer,

    secondary           = Teal80,
    onSecondary         = OnTeal,
    secondaryContainer  = TealContainer,
    onSecondaryContainer = OnTealContainer,

    tertiary            = Orange80,
    onTertiary          = OnOrange,
    tertiaryContainer   = OrangeContainer,
    onTertiaryContainer = OnOrangeContainer,

    background          = Background,
    onBackground        = OnBackground,

    surface             = Surface,
    onSurface           = OnSurface,
    surfaceVariant      = SurfaceVariant,
    onSurfaceVariant    = OnSurfaceVariant,

    outline             = Outline,

    error               = Error,
    onError             = OnError,
    errorContainer      = ErrorContainer,
    onErrorContainer    = OnErrorContainer,
)

val WordVoyageTypography = Typography(
    displayMedium = TextStyle(
        fontWeight = FontWeight.Bold,
        fontSize = 45.sp,
        letterSpacing = 0.sp
    ),
    displaySmall = TextStyle(
        fontWeight = FontWeight.Bold,
        fontSize = 36.sp
    ),
    headlineSmall = TextStyle(
        fontWeight = FontWeight.SemiBold,
        fontSize = 24.sp
    ),
    titleLarge = TextStyle(
        fontWeight = FontWeight.Bold,
        fontSize = 20.sp
    ),
    titleMedium = TextStyle(
        fontWeight = FontWeight.SemiBold,
        fontSize = 18.sp
    ),
    bodyLarge = TextStyle(
        fontWeight = FontWeight.Normal,
        fontSize = 16.sp,
        lineHeight = 24.sp
    ),
    bodyMedium = TextStyle(
        fontWeight = FontWeight.Normal,
        fontSize = 14.sp,
        lineHeight = 20.sp
    ),
    labelLarge = TextStyle(
        fontWeight = FontWeight.Medium,
        fontSize = 14.sp
    ),
    labelMedium = TextStyle(
        fontWeight = FontWeight.Medium,
        fontSize = 12.sp
    ),
)

@Composable
fun WordVoyageTheme(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = WordVoyageColorScheme,
        typography = WordVoyageTypography,
        content = content
    )
}

